import { Hint, Label, Select } from '@lokalise/louis';

import type { ExportEmpty } from '../../../../types';

type Option = { value: ExportEmpty; label: string };

export interface ExportEmptyInputProps {
    value: ExportEmpty;
    options: readonly Option[];
    onChange: (value: ExportEmpty) => void;
}

const ExportEmptyInput = ({ value, options, onChange }: ExportEmptyInputProps) => (
    <Label
        id="ExportEmptyInput"
        text={
            <>
                Empty translations{' '}
                <Hint>
                    Using this option you can choose what to do with the keys that have no translation at all. The
                    default action is to export and assign empty strings as the translation values. You can also choose
                    not to export these keys at all, or provide the base language as a value. Certain file formats may
                    have additional options.
                </Hint>
            </>
        }
    >
        <Select
            aria-labelledby="ExportEmptyInput"
            value={options.filter((item) => value === item.value)[0]}
            options={options}
            onChange={(val) => {
                if (val === null) {
                    return;
                }
                onChange(val.value);
            }}
        />
    </Label>
);

export default ExportEmptyInput;
